export default {
  install(Vue) {
    // 防止重复点击
    Vue.directive('preventClick', {
      inserted(el, binding) {
        console.log('哈哈哈哈')
        el.addEventListener('click', () => {
          if (!el.disabled) {
            el.disabled = true
            setTimeout(() => {
              el.disabled = false
            }, 2000)
          }
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/directive/permission/preventClick.js